import { MtPackageAllowed, SaveMtPackageAllowedType } from "server/models"
import { GET, POST } from "client/store/utils"
import { PackageAllowedList } from "../types"


export const LoadAllPackageAllowed = () => (
    GET("/mtPackageAllowed/all")
    .then((allowedPackages: MtPackageAllowed[]) => {
        const packageAllowedList: PackageAllowedList = {}
        allowedPackages.forEach((row) => {
            if (!packageAllowedList[row.packageId]) {
                packageAllowedList[row.packageId] = []
            }
            packageAllowedList[row.packageId].push(row.accountId)
        })
        return packageAllowedList
    })
)

export const LoadAllowedAccountsForPackage = (packageId: number) => (
    GET(`/mtPackageAllowed/allowedAccounts/${packageId}`)
    .then((allowedPackages: MtPackageAllowed[]) => {
        const accountIds: number[] = []
        allowedPackages.forEach((row) => {
            accountIds.push(row.accountId)
        })
        return accountIds
    })
)

export const LoadAllowedPackagesForAccount = (accountId: number) => (
    GET(`/mtPackageAllowed/allowedPackages/${accountId}`)
    .then((allowedPackages: MtPackageAllowed[]) => {
        const packageIds: number[] = []
        allowedPackages.forEach((row) => {
            packageIds.push(row.packageId)
        })
        return packageIds
    })
)

export const SaveAllowedPackages = (
    packageId: number,
    allowedPackages: MtPackageAllowed[],
) => {
    const allowedPackagesData: SaveMtPackageAllowedType = {
        packageId,
        allowedPackages,
    }
    return POST(
        "/mtPackageAllowed/save",
        JSON.stringify(allowedPackagesData),
    ).then(() => (
        LoadAllowedAccountsForPackage(packageId)
    ))
}
